import { render } from "./BlockSocios.vue?vue&type=template&id=c3cbcc32"
import script from "./BlockSocios.vue?vue&type=script&lang=js"
export * from "./BlockSocios.vue?vue&type=script&lang=js"

import exportComponent from "/build/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/components/CampoForm/components/BlockSocios.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "c3cbcc32"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('c3cbcc32', __exports__)) {
    console.log('reload')
    api.reload('c3cbcc32', __exports__)
  }
  
  module.hot.accept("./BlockSocios.vue?vue&type=template&id=c3cbcc32", () => {
    console.log('re-render')
    api.rerender('c3cbcc32', render)
  })

}


export default __exports__